import { Box } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { useRef } from 'react';
import { Button } from 'src/design-system/Button';
import { useContentPaneBottomInset } from 'src/UI/app-container/ContentPaneBottomInset';

type Props = {
  onFinalise: () => void;
};

// Sticky rather than fixed, so it keeps its own space and can never cover the last row. The auto
// top margin takes the free space in its column, holding it at the bottom of a short review.
export function FloatingFinaliseButton({ onFinalise }: Props) {
  const stripRef = useRef<HTMLDivElement>(null);
  useContentPaneBottomInset(stripRef);

  return (
    <Box
      ref={stripRef}
      data-testid="floating-finalise"
      mt="auto"
      pt="xl"
      pb="md"
      style={{
        position: 'sticky',
        bottom: 0,
        zIndex: 'var(--mantine-z-index-app)',
        display: 'flex',
        justifyContent: 'flex-end',
        // Rows passing behind the strip stay clickable everywhere but under the button.
        pointerEvents: 'none',
      }}
    >
      <Button
        variant="primary"
        size="md"
        onClick={onFinalise}
        leftSection={<IconCheck size={16} />}
        style={{ pointerEvents: 'auto', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)' }}
      >
        Finalise data
      </Button>
    </Box>
  );
}
